// extracted by mini-css-extract-plugin
export var dividerLine = "_6n-3";
export var itemImage = "_6n-9";
export var lightDivider = "_6n-4";
export var modalContent = "_6n-5";
export var modalContentCompact = "_6n-6";
export var productCard = "_6n-a";
export var productImage = "_6n-b";
export var productImageCompact = "_6n-7";
export var productImagePlaceholder = "_6n-c";
export var productImagePlaceholderCompact = "_6n-8";
export var progressBarBackground = "_6n-1";
export var progressBarContainer = "_6n-0";
export var progressBarFill = "_6n-2";